/**
 * Seasonal pricing for Villas Yaiza
 * Low season: Feb, Mar, Apr, May -> €160/night
 * High season: all other months -> €190/night
 *
 * Some villas use a flat rate instead of seasonal pricing,
 * e.g. Casa de El Golfo is a flat €80/night all year round.
 */
const FLAT_RATES: Record<string, number> = {
  'casa-de-el-golfo': 80,
};

export function getFlatRateForVilla(villaSlug: string): number | null {
  return FLAT_RATES[villaSlug] ?? null;
}

export function getSeasonalRate(dateStr: string, villaSlug?: string): number {
  if (villaSlug && FLAT_RATES[villaSlug] != null) {
    return FLAT_RATES[villaSlug];
  }
  const month = parseInt(dateStr.split('-')[1], 10) - 1; // 0-indexed month
  // Low season: February (1), March (2), April (3), May (4)
  if ([1, 2, 3, 4].includes(month)) return 160;
  // High season: everything else
  return 190;
}

export function addDays(dateStr: string, n: number): string {
  const [y, m, d] = dateStr.split('-').map(Number);
  const dt = new Date(y, m - 1, d + n);
  return toDateStr(dt);
}

export function toDateStr(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function calculateSeasonalTotal(
  checkIn: string,
  checkOut: string,
  villaSlug?: string
): number {
  let total = 0;
  let d = checkIn;
  while (d < checkOut) {
    total += getSeasonalRate(d, villaSlug);
    d = addDays(d, 1);
  }
  return total;
}

export function getSeasonBreakdown(
  checkIn: string,
  checkOut: string,
  villaSlug?: string
): {
  nights: number;
  total: number;
  avgPerNight: number;
} {
  const nights = Math.round(
    (new Date(checkOut).getTime() - new Date(checkIn).getTime()) / 86400000
  );
  const total = calculateSeasonalTotal(checkIn, checkOut, villaSlug);
  return { nights, total, avgPerNight: Math.round((total / nights) * 100) / 100 };
}